import ENDPOINTS from 'api/endpoints';
import { doGet, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { TaskResultResponse } from './types';

export const getAssistantTasksResults = (params: {
  accountId: string;
  projectId: string;
  conversationId: string;
  taskId: string;
}) => {
  return doGet<TaskResultResponse>(
    generateNextPath(ENDPOINTS.TASK_RESULTS, params),
    LOGGER_TYPE.ANALYTICS,
  );
};

export const updateAssistantTasksResults = ({
  categoryId,
  ...params
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
  taskId: string;
  categoryId: string;
}) => {
  return doPut<TaskResultResponse>(
    generateNextPath(ENDPOINTS.TASK_RESULTS, params),
    LOGGER_TYPE.ANALYTICS,
    {
      annotator: 'user',
      status: 'corrected',
      category_id: categoryId,
    },
  );
};
